import React, { useState } from "react";
import InfoPage from ".";

const HostSignup = () => {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const category = (params.get('category') || '').toLowerCase();
  const validCategory = ['vacation_rental','boutique_hotel','tourism_board'].includes(category) ? category : null;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      if (!password || password.length < 8) { setSubmitStatus('error'); setIsSubmitting(false); return; }
      if (confirmPassword && password !== confirmPassword) { setSubmitStatus('error'); setIsSubmitting(false); return; }
      const response = await fetch('/api/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          role: 'host',
          hostCategory: validCategory,
          firstName,
          lastName,
          email,
          paypalEmail: paypalEmail || null,
          password,
        }),
      });

      if (response.ok) {
        const json = await response.json();

        setSubmitStatus('success');
        try { 
          if (email) {
            window.localStorage.setItem('postaway_email', email);
            window.localStorage.setItem('postaway_user_type', 'host');
          }
        } catch (_) {}
        try {
          if (json.token) {
            localStorage.setItem('postaway_auth_token', json.token);
          }
          if (json.user) {
            localStorage.setItem('postaway_user_data', JSON.stringify(json.user));
          }
        } catch (_) {}
        setPassword('');
        setConfirmPassword('');
        const qs = new URLSearchParams({ firstName, email, category: validCategory || 'vacation_rental' }).toString();
        window.location.assign(`/host/onboarding?${qs}`);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const belowContent = (
    <>
      {/* Left side - Image */}
      <div className="login-left">
        <img src="/house.png" alt="Host Signup" className="login-image" />
        <p className="login-welcome">
          {validCategory ? `Join as ${validCategory.replace('_',' ')}` : 'Join our host community'}
        </p>
        <div className="login-signup-link">
          Already a member? <a href="/host-login">Login</a>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="login-right">
        <form onSubmit={handleSubmit} className="login-form">
          {/* Header */}
          <h3 className="login-title">
            {validCategory ? `Create your ${validCategory.replace('_',' ')}` : 'Create your host'} account
          </h3>

          {/* First Name field */}
          <div className="login-input-group">
            <input
              type="text"
              placeholder=""
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              className="login-input"
            />
            <label className="login-label">First Name</label>
          </div>

          {/* Last Name field */}
          <div className="login-input-group">
            <input
              type="text"
              placeholder=""
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              className="login-input"
            />
            <label className="login-label">Last Name</label>
          </div>

          {/* Email field */}
          <div className="login-input-group">
            <input
              type="email"
              placeholder=""
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="login-input"
            />
            <label className="login-label">Email Address</label>
          </div>

          {/* PayPal Email field (optional) */}
          <div className="login-input-group">
            <input
              type="email"
              placeholder=""
              value={paypalEmail}
              onChange={(e) => setPaypalEmail(e.target.value)}
              className="login-input"
            />
            <label className="login-label">PayPal Email (optional)</label>
          </div>

          {/* Password field */}
          <div className="login-input-group">
            <div className="login-password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="login-input login-input-password"
              />
              <button type="button" onClick={() => setShowPassword(s => !s)} aria-label="Toggle password visibility" aria-pressed={showPassword} className="login-password-toggle">
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
                    <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
                    <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
                    <path d="m2 2 20 20" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
            <label className="login-label">Password</label>
          </div>

          {/* Confirm Password (appears when typing) */}
          {password && (
            <div className="login-input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder=""
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="login-input"
                style={{
                  borderBottom: `2px solid ${confirmPassword && confirmPassword !== password ? '#dc1d08' : 'rgba(0,0,0,.12)'}`
                }}
              />
              <label className="login-label">Confirm Password</label>
            </div>
          )}

          {/* Submit Button */}
          <button type="submit" disabled={isSubmitting} className="login-submit">
            {isSubmitting ? 'Submitting...' : 'Sign Up'}
          </button>

          {/* Status Message */}
          {submitStatus === 'success' && (
            <p className="login-success">
              Successfully signed up!
            </p>
          )}
          {submitStatus === 'error' && (
            <p className="login-error">
              Error signing up. Please try again.
            </p>
          )}
          
          {/* Terms of Use */}
          <div className="login-agreement">
            By subscribing to Postaway and becoming a member, I will abide by and be bound by the{' '}
            <a href="/member-agreement">Postaway Terms of Use</a> and <a href="/privacy-policy">Privacy Policy</a>.
          </div>
        </form>
      </div>
    </>
  );

  return <InfoPage title="Host Signup" divider belowContent={belowContent} disableStamps />;
};

export default HostSignup;

